export const cpdPointsSelector = (state) => state.cpdPoints.cpdPoints;

export const exportCpdSelector = (state) => state.cpdPoints.exportCpdPoints;

export const cpdActivityHitsSelector = (state) => state.cpdPoints.filterHits;

export const cpdPointRelatedTasksSelector = (state) => state.cpdPoints.relatedTasks;


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/selectors.js